import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  label: string;
  subLabel?: string;
  size?: 'md' | 'lg';
  className?: string;
  href?: string;
}
export function CtaButton({
  label,
  subLabel,
  size = 'md',
  className = '',
  href = '#comprar'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-10 py-5 text-lg' : 'px-8 py-4 text-base';
  const isExternal = href.startsWith('http');
  return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`group inline-flex items-center justify-center gap-3 rounded-lg bg-flare-500 font-bold uppercase tracking-wide text-ink-950 shadow-lg shadow-flare-500/20 transition-[background-color,transform] duration-150 ease-swift hover:bg-flare-400 active:translate-y-px focus:outline-none focus-visible:ring-4 focus-visible:ring-flare-500/40 ${sizing} ${className}`} data-id="element-66" data-mp="qj91ep7cdv6d">
      <span className="text-left leading-tight" style={{
      textAlign: "center"
    }} data-id="element-67" data-mp="15ahn4n84iwe8">
        {label}
        {subLabel ? <span className="block text-[11px] font-semibold uppercase tracking-[0.18em] text-ink-800/80" data-id="element-68" data-mp="35yqsd7tp8f1x">
            {subLabel}
          </span> : null}
      </span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-swift group-hover:translate-x-1" aria-hidden="true" data-id="element-69" data-mp="3exb0xg5jp8cf" />
    </a>;
}